import App from './App.svelte'

// if (!document.getElementById('hh-mfe-pdp-reviews')) {
// 	let newMount = document.createElement('div')
// 	newMount.setAttribute('id', 'hh-mfe-pdp-reviews')
// 	document.body.appendChild(newMount)
// }

const mount	= document.getElementById('pdp-review-section')
const lang	= document.querySelector('html').lang || 'en'

if (mount) {
	mount.innerHTML = null
	new App({
		target: mount,
		props: {
			lang: lang,
			dataset: mount.dataset
		}
	})
}